import { ApToggleSwitch, colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const TooltipContainer = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	padding: 8px 12px;
	margin: 0;
	z-index: 2;
	background-color: ${colors.white};
	#tooltip_content {
		display: flex;
		flex-direction: column;
	}
`;

export const TooltipItemTitle = styled.strong`
	font-size: 13px;
	font-weight: bold;
`;

export const FilterWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	column-gap: 1%;
	#price_filter,
	#commodity_l2_filter,
	#commodity_l3_filter {
		border: 1px solid #cccccc;
	}
	#scale_marker_by_volume {
		display: flex;
		align-items: center;
	}
`;

export const StatsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin-top: 35px;
`;

export const KPISection = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	gap: 10px;
`;

export const KpiCard = styled.div`
	width: 100%;
	padding: 1em;
	margin: 0.5% 0;
	background-color: ${colors.white};
	box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
`;

export const CardValue = styled.div`
	font-size: 1.3rem;
	font-weight: bolder;
`;

export const CardText = styled.div`
	font-size: 0.8rem;
	padding-left: 0.2em;
`;

export const ToggleSwitch = styled(ApToggleSwitch)`
	margin: 2px 0 0 3px;
`;

export const TableWrapper = styled.div`
	width: 100%;
	height: 100%;
	overflow-y: auto;

	.ag-theme-balham {
		width: 100%;
		height: 100%;
		font-family: 'Roboto';

		.ag-root,
		.ag-side-bar,
		.ag-root-wrapper,
		.ag-status-bar {
		}

		.ag-header-row {
			border-bottom: 0px;
		}

		.ag-header {
			padding: 0px;
			background-color: #5cb335;
			color: white;
			.ag-header-cell-resize {
				display: none;
			}
			.ag-icon {
				color: #fff;
			}
		}
		.ag-header-group-cell::after {
			display: none;
		}
		.ag-header-cell-sorted-none::after {
			display: none;
		}
		.ag-header-cell {
			font-weight: bold;
			font-size: 8px;
			font-family: 'Roboto';
			text-transform: uppercase;
			.ag-header-cell-text {
				white-space: pre-line;
			}
			.ag-icon-menu {
				display: none;
			}
			&.ag-numeric-header {
				text-align: right;
			}
		}
		.ag-header-group-cell-no-group {
			background-color: #ffffff;
			border: none;
		}
		.ag-header-group-cell-label {
			justify-content: center;
		}

		.ag-row {
			background-color: transparent;
			border-color: ${colors.grey3};

			&.ag-row-last {
				border-bottom: none;
			}
			&:hover {
				background-color: rgba(0, 255, 0, 0.12);
			}
			.ag-cell {
				font-size: 8px;
				font-weight: normal;
				color: ${colors.grey5};
			}
		}

		.ag-floating-top-viewport {
			border: none;
		}

		.ag-floating-top {
			border-color: ${colors.grey3};
		}

		.ag-row-pinned {
			border: none;

			&.ag-row-last {
				border: none;
			}

			.ag-cell {
				font-weight: bold;
			}
		}

		.ag-header-row-column {
			border-bottom: 1px solid ${colors.grey3};
		}
	}
`;
